export default "__VITE_ASSET__bZspSQTV__"